export default __webpack_public_path__ + "static/media/elevate-gry-banner-2.fb149f5e.jpg";